import Image from 'next/image'
import Link from 'next/link'
import React, { FC } from 'react'

import { HeroInfoBlock } from '@/widgets/HeroInfoBlock'

import { FaqSection } from '@/shared/ui/FaqSection'
import { Col, Row } from '@/shared/ui/Grid'
import { HorizontalSection } from '@/shared/ui/HorizontalSection'
import { VerticalSection } from '@/shared/ui/VerticalSection'

import { cardBenefits, faqItems, heroInfoData } from './data'
import { GiftBenefitsList } from './ui/GiftBenefitsList/GiftBenefitsList'

import styles from './GiftCard.module.scss'

export const GiftCards: FC = () => (
	<div className={styles.giftsPage}>
		<HeroInfoBlock
			{...heroInfoData}
			imgWidth={927}
			imgHeight={492}
			bgColor={`#ffffff`}
			customSubtitle={
				<p className={styles.subtitle}>
					Карту можно приобрести в&nbsp;любом
					<span className={styles.linkWrap}>
						<Link prefetch={false} href={`/shops/`} className={styles.shopLink} target="_blank" rel="noreferrer">
							розничном магазине iPort
						</Link>
					</span>
				</p>
			}
		/>

		<VerticalSection title="Преимущества" borderNone>
			<GiftBenefitsList items={cardBenefits} />
		</VerticalSection>

		<section className={styles.benefits}>
			<Row>
				<Col lg={{ order: 0, span: 15 }} xs={{ span: 24, order: 1 }}>
					<div className={styles.purchaseWrap}>
						<h2 className={styles.title}>
							Приобрести карту <br />в любом розничном магазине iPort
						</h2>
						<Link
							prefetch={false}
							href={`https://www.iport.ru/shops/`}
							className={styles.chooseShopLink}
							target="_blank"
							rel="noreferrer">
							Выбрать магазин
						</Link>
					</div>
				</Col>

				<Col lg={9} xs={{ span: 20, order: 0 }}>
					<div className={styles.imgWrap}>
						<Image
							src={`https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/mock-images/giftCardPurchase.png`}
							alt={`Подарочная карта iPort`}
							width={333}
							height={391}
						/>
					</div>
				</Col>
			</Row>
		</section>

		<HorizontalSection title="Правила использования карты" borderNone>
			<FaqSection items={faqItems} />
			<p className={styles.note}>Используя подарочную карту вы соглашаетесь с настоящими правилами.</p>
		</HorizontalSection>
	</div>
)
